import { render } from "./FleetPage.vue?vue&type=template&id=1b92a7e5&scoped=true"
import script from "./FleetPage.vue?vue&type=script&lang=js"
export * from "./FleetPage.vue?vue&type=script&lang=js"

import "./FleetPage.vue?vue&type=style&index=0&id=1b92a7e5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b92a7e5"]])

export default __exports__